export default async (categorisable, behaviour) => {
  const category = await categorisable.populate('category');
  const subcategory =
    category &&
    category.children.find(ac => ac.id === categorisable.subcategory);

  return subcategory && subcategory.behaviours.includes(behaviour);
};
